import React from "react";
import { Input, Row, Typography, Form, Col } from "antd";
const { Text } = Typography;

const ReconcilationAndControl = (props) => {
  const { onFinish, form, formData, glDetail } = props;
  const displayValue = (value) =>
    value !== undefined && value !== null && value !== "" ? value : "-";
  const yesNo = (value) => (value === true ? "Yes" : value === false ? "No" : "-");
  const controlAccountFlagMap = {
    primary: "Primary",
    secondary: "Secondary",
    suspense: "Suspense",
  };
  return (
    <Form layout="vertical" onFinish={onFinish} form={form} initialValues={formData}>
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Control Account Flag</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(
                controlAccountFlagMap[glDetail?.controlAccountFlag] || glDetail?.controlAccountFlag,
              )}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Control Account Flag (Yes/No)</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={yesNo(glDetail?.controlAccountFlagYesNo)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>External Reconciliation Code</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(glDetail?.externalReconciliationCode)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Settlement Flag</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(glDetail?.settlementFlag)}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default ReconcilationAndControl;
